<template>
    <common-modal
        height="small"
        width="extra-large"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <common-loader v-if="isProcessing" :isProcessing="isProcessing"></common-loader>
        <div v-else class="avaiable-locations">
            <common-content-spacer height="medium">
                <common-page-header class="available-locations-header" :heading="'Please choose location'"></common-page-header>
                <availability-locations
                    :hoverTitle="$t('pages.profile.professional.availability.check')"
                    :maxNumberOfItems="maxNumberOfItems"
                    :locations="locations"
                    @go-to-location="goToTimeProposal($event)"
                ></availability-locations>
            </common-content-spacer>
        </div>
    </common-modal>
</template>

<script>
    import AvailabilityLocations from 'components/page-elements/profile/AvailabilityLocations'
    import dayjs from 'dayjs'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: { AvailabilityLocations },

        props: {
            referral: { type: Object, required: true },
            locations: { type: Array, required: true },
        },

        data() {
            return {
                isProcessing: false,
            }
        },

        computed: {
            maxNumberOfItems() {
                if (this.isTablet) {
                    return 1
                }
                if (this.isLaptop) {
                    return 2
                }

                return 3
            },
        },

        methods: {
            goToTimeProposal(event) {
                if (this.$listeners['go-to-location']) {
                    this.$emit('go-to-location', event)
                    return
                }
                this.$router.push({
                    name: `referrals.pool.propose.time`,
                    params: {
                        poolId: this.referral.id,
                        locationId: event.practiceLocationId,
                    },
                    query: {
                        physicianId: this.$auth.getActiveMember()?.id
                            ? this.$auth.getActiveMember()?.id
                            : this.$auth.getUser().id,
                        practiceId: this.$auth.getPractice().id,
                        userId: this.getUserId(),
                        practiceLocationId: event.practiceLocationId,
                        fromUserId: this.referral?.fromUser?.id,
                        timeFrame: this.referral?.timeframe,
                        fromDate: dayjs(this.referral?.createdAt).format('YYYY-MM-DD'),
                        distance: event.distance ?? undefined,
                        practiceType: this.$auth.getPractice().practiceType,
                        isFromPatient: this.referral?.isFromPatient,
                        patientId: this.referral?.patientId,
                    },
                })
            },

            getUserId() {
                if (this.$auth.getPractice().practiceType !== PracticeTypeEnum.ANCILLARY) {
                    return this.$auth.getActiveMember()?.id ? this.$auth.getActiveMember()?.id : this.$auth.getUser().id
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .content {
        max-height: 500px;
        overflow-y: auto;
    }

    .providers-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 10px 10px;
        overflow-x: hidden;
    }

    .no-locations-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    .available-locations-header {
        text-align: center;
    }
</style>
